import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { NotificationsOutline } from "react-ionicons";
import { useAppSelector } from "src/app/services/store";
import { useAppDispatch } from "src/app/services/store";
import { AppRoutes } from "src/app/navigation/routes";
import { getNotificationsUnreadCount } from "src/shared/redux-state/src/lib/notifications/NotificationSelector";
import { fetchNotificationUnReadCount } from "src/shared/redux-state/src/lib/notifications/NotificationHandler";

const NotificationBell = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const unreadCount = useAppSelector(getNotificationsUnreadCount);
 
    const fetchDataPeriodically = async () => {
        dispatch(fetchNotificationUnReadCount());
    };

    useEffect(() => {
        fetchDataPeriodically();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className='px-2 cursor-pointer' onClick={() => navigate(AppRoutes.NOTIFICATIONS)}>
            <div className='d-flex'>
                <NotificationsOutline
                    color={'#00000'}
                    height="20px"
                    width="20px"
                />
                {!!unreadCount && <span className='badge'>{unreadCount}</span>}
            </div>
        </div>
    );
};

export default NotificationBell;